export const PROFESSIONAL_SEARCH_ENTRY_POINTS = 'professional_search_entry_points';
